import React, { useState, useEffect } from 'react';  
// import { Line } from 'react-chartjs-2';  
import styled from 'styled-components';  
import { farmDataByGreenhouse } from './farmData';  // データをインポート
import { Bar } from 'react-chartjs-2';  // LineからBarに変更

// グラフを包むコンテナのスタイルを統一
const ChartWrapper = styled.div`  
  background-color: #ffffff;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 5px;
  flex: 1;
  min-height: 300px;
  max-height: 300px;
  @media (max-width: 768px) {
    min-height: 300px;
  }
`;  

const ChartsContainer = styled.div`  
  display: flex;  
  flex-direction: column;  
  width: 100%;  
  gap: 20px;
  // @media (min-width: 768px) {  
  //   width: 50%;  
  // }  
`;  

// const ChartItem = ({ data, options, onClick }) => (  
//   <ChartWrapper>  
//     <Line data={data} options={options} onClick={onClick} />  
//   </ChartWrapper>  
// );  

const HarvestChart = ({ greenhouse }) => {  // 上位から渡された greenhouse を使用
  const [chartData, setChartData] = useState(null);  
  const [isExpanded, setIsExpanded] = useState(false);  

  useEffect(() => {  
    if (!greenhouse) return; // greenhouse がない場合は何もしない

    const data = farmDataByGreenhouse[greenhouse];  // 渡された greenhouse に応じたデータを取得
    if (data) {
      const labels = data.map(item => item.date);  
      const weights = data.map(item => item.weight / 1000); // kgをtに変換  
      // const cumulativeWeights = data.reduce((acc, current, index) => {  
      //   const prevValue = index === 0 ? 0 : acc[index - 1];  
      //   acc.push(prevValue + current.weight / 1000); // kgをtに変換  
      //   return acc;  
      // }, []);  

      setChartData({  
        labels: labels,  
        datasets: [  
          {  
            type: 'bar',  
            label: '収穫量 (t)',  
            data: weights,  
            backgroundColor: 'rgba(0, 128, 0, 0.5)',  
            yAxisID: 'y-axis-weight',  
          },  
          // {  
          //   type: 'line',  
          //   label: '累積収穫量 (t)',  
          //   data: cumulativeWeights,  
          //   fill: false,  
          //   borderColor: 'lightgreen',  
          //   borderDash: [5, 5],  
          //   yAxisID: 'y-axis-weight',  
          // },  
        ],  
      });  
    }
  }, [greenhouse]);  // greenhouse が変更されるたびにデータを更新

  const chartOptions = {  
    maintainAspectRatio: false,
    plugins: {  
      legend: {  
        labels: {  
          color: 'black',  
        },  
      },  
      datalabels: { 
        display: false,  
      }, 
    },  
    scales: {  
      x: {  
        grid: {  
          color: 'rgba(0, 0, 0, 0.1)',  
        },  
        ticks: {  
          color: 'black',  
        },  
      },  
      'y-axis-weight': {  
        type: 'linear',  
        position: 'left',  
        grid: {  
          color: 'rgba(0, 0, 0, 0.1)',  
        },  
        ticks: {  
          color: 'black',  
        },  
        title: {  
          display: true,  
          text: '重量 (t)',  
          color: 'black',  
        },  
        min: 0,  
      },  
    },  
    animation: {
      duration: 1000,  // アニメーションの長さ（ミリ秒）
      easing: 'easeInOutQuart',  // アニメーションの動き方
      onComplete: () => {
        // console.log('Animation complete');
      }
    }
  };  

  const handleChartClick = () => {  
    setIsExpanded(!isExpanded);  
  };

  return (  
    <ChartsContainer>  
      {/* {isExpanded ? (  
        <>  
          <ChartItem  
            data={{  
              labels: chartData.labels,  
              datasets: [  
                {  
                  type: 'line',  
                  label: '収穫量 (t)',  
                  data: chartData.datasets[0].data,  
                  fill: false,  
                  borderColor: 'green',  
                  yAxisID: 'y-axis-weight',  
                },  
              ],  
            }}  
            options={chartOptions}  
            onClick={handleChartClick}  
          />  
          <ChartItem  
            data={{  
              labels: chartData.labels,  
              datasets: [  
                {  
                  type: 'line',  
                  label: '累積収穫量 (t)',  
                  data: chartData.datasets[1].data,  
                  fill: false,  
                  borderColor: 'lightgreen',  
                  borderDash: [5, 5],  
                  yAxisID: 'y-axis-weight',  
                },  
              ],  
            }}  
            options={chartOptions}  
            onClick={handleChartClick}  
          />  
        </>  
      ) : (   */}
        <ChartWrapper>  
          {chartData ? (  
            <Bar data={chartData} options={chartOptions} onClick={handleChartClick} />  
          ) : (  
            <p>Loading...</p>  
          )}  
        </ChartWrapper>  
      {/* )}   */}
    </ChartsContainer>  
  );  
};  

export default HarvestChart;
